module.exports = __webpack_public_path__ + "static/media/25.019ae9ba.mp3";